const Dropdown = require('lib/dropdown');
const MobileMenu = require('lib/mobile-menu');


(function setDropdowns() {
    $.find('.nav-container .menu-item').forEach(function(el) {
        Dropdown($(el), $(el).find('.dropdown-overlay-container'));
    });
}());


MobileMenu('.mobile-menu', '.mobile-nav-container');


// WEBPACK FOOTER //
// ./assets/js/app/includes/nav.js